// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"92b384022236e6e9eec9","339":"312167b7d45670ed237b"}[chunkId] + ".js";
};